import {createInstance} from 'i18next';
import {initReactI18next} from 'react-i18next';
import {DEFAULT_LANGUAGE} from './languages';
import english from './translations/en.json';

export function createI18n(lang = DEFAULT_LANGUAGE, resources = {[DEFAULT_LANGUAGE]: {translation: english}}) {
    const instance = createInstance();
    instance.use(initReactI18next).init({
        lng: lang,
        resources,
        fallbackLng: DEFAULT_LANGUAGE,
        initAsync: false,
        interpolation: {escapeValue: false},
    });
    return instance;
}
